import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useCart } from '@context/CartContext';
import { ROUTES } from '@utils/constants';
import Button from '@components/common/Button';

interface CartIconProps {
  className?: string;
  showText?: boolean;
}

const CartIcon: React.FC<CartIconProps> = ({ className, showText = false }) => {
  const { itemCount } = useCart();

  return (
    <Link to={ROUTES.CART}>
      <Button
        variant="ghost"
        size="medium"
        className={clsx('relative', className)}
        icon={<ShoppingCart size={20} />}
      >
        {showText && <span className="ml-2">Cart</span>}

        {itemCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-primary-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center min-w-[1.25rem] animate-zoom-in">
            {itemCount > 99 ? '99+' : itemCount}
          </span>
        )}
      </Button>
    </Link>
  );
};

export default CartIcon;
